import React, { useEffect, useState } from 'react'
import ImageUploader from 'react-image-upload'
import 'react-image-upload/dist/index.css'
import Swal from 'sweetalert2';

const AddIdCard = () => {
    const [sp, setSp] = useState([]);
    const [idcard, setidcard] = useState([]);
    const [editItem, setEditItem] = useState(null);
    const [ShowModal, setShowModal] = useState(false)
    const [formData, setFormData] = useState({
        name: '',
        designation: '',
        department: '',
        companyaddress: '',
        emergencycontact: '',
        image: null,
        spid: ''
    });

    const [editFormData, setEditFormData] = useState({
        name: '',
        designation: '',
        department: '',
        companyaddress: '',
        emergencycontact: '',
        image: null,
        spid: ''
    });

    const [viewItem, setViewItem] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        setFormData(prev => ({
            ...prev,
            image: e.target.files[0]
        }));
    };

    const getIdCard = async () =>{
        try {
            const requestOptions = {
                method: "GET",
                redirect: "follow"
              };
              
              fetch("https://api.experts4u.in/api/v2/IdCard/GetIdCard", requestOptions)
                .then((response) => response.json())
                .then((result) => {console.log(result)
                    setidcard(result);
                })
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);

            
        }
    }

    const getSp = async () =>{
        try {

            const requestOptions = {
                method: "GET",
                redirect: "follow"
              };
              
              fetch("https://api.experts4u.in/api/v2/IdCard/GetServiceProvider", requestOptions)
                .then((response) => response.json())
                .then((result) => {console.log(result)
                    setSp(result);
                })
                .catch((error) => console.error(error));
            
        } catch (error) {
            console.error(error);
            
        }
    }

    const CardCreate = async (e) => {
        e.preventDefault();
        try {
            const formdata = new FormData();
            formdata.append("name", formData.name);
            formdata.append("image", formData.image);
            formdata.append("designation", formData.designation);
            formdata.append("department", formData.department);
            formdata.append("companyaddress", formData.companyaddress);
            formdata.append("emergencycontact", formData.emergencycontact);
            formdata.append("spid", formData.spid);

            const requestOptions = {
                method: "POST",
                body: formdata,
                redirect: "follow"
            };

            const response = await fetch("https://api.experts4u.in/api/v2/IdCard/CreateIdCard", requestOptions);
            const result = await response.text();
            console.log(result);
            // Clear form after successful submission
            setFormData({
                name: '',
                designation: '',
                department: '',
                companyaddress: '',
                emergencycontact: '',
                image: null
            });
            getIdCard();
        } catch (error) {
            console.error(error);
        }
    }

    const handleEdit = (item) => {
        setShowModal(true);
        setEditItem(item);

    }

    const handleDelete = (id) => {
        try {
            const requestOptions = {
                method: "DELETE",
                redirect: "follow"
              };
              
              fetch(`https://api.experts4u.in/api/v2/IdCard/DeleteIdCard/${id}`, requestOptions)
                .then((response) => response.json())
                .then((result) => {console.log(result)
                    getIdCard();
                    Swal.fire("Success!", "Id card deleted successfully.", "success");
                })
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);

            
            
        }
    }

    const handleView = (id) => {
        const item = idcard.find(card => card._id === id);
        setViewItem(item);
        setShowViewModal(true);
    }

    function getImageFileObject(imageFile) {
        console.log({ imageFile })
      }
    
      function runAfterImageDelete(file) {
        console.log({ file })
      }

    useEffect(() => {
        getSp();
        getIdCard();
    }, []);

    useEffect(() => {
        if (editItem) {
            setEditFormData({
                name: editItem.name || '',
                designation: editItem.designation || '',
                department: editItem.department || '',
                companyaddress: editItem.companyaddress || '',
                emergencycontact: editItem.emergencycontact || '',
                spid: editItem.spid || '',
                image: editItem.image || null
            });
        }
    }, [editItem]);

    const handleEditImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setEditFormData(prev => ({
                ...prev,
                image: file
            }));
        }
    };

    const handleEditFormSubmit = async (e) => {
        e.preventDefault();
        try {
            const formdata = new FormData();
            formdata.append("name", editFormData.name);
            if (editFormData.image instanceof File) {
                formdata.append("image", editFormData.image);
            }
            formdata.append("designation", editFormData.designation);
            formdata.append("department", editFormData.department);
            formdata.append("companyaddress", editFormData.companyaddress);
            formdata.append("emergencycontact", editFormData.emergencycontact);
            formdata.append("spid", editFormData.spid);

            const requestOptions = {
                method: "PUT",
                body: formdata,
                redirect: "follow"
            };

            const response = await fetch(`https://api.experts4u.in/api/v2/IdCard/UpdateIdCard/${editItem._id}`, requestOptions);
            const result = await response.text();
            console.log(result);
            setShowModal(false);
            getIdCard(); // Refresh the list
        } catch (error) {
            console.error(error);
        }
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const removeImage = () => {
        setEditFormData(prev => ({
            ...prev,
            image: null
        }));
    };


    const updateImage = () => {
        try {
            const formdata = new FormData();
            formdata.append("image", editFormData?.image);

            const requestOptions = {
                method: "PUT",
                body: formdata,
                redirect: "follow"
            };

            fetch(`https://api.experts4u.in/api/v2/IdCard/UpdateIdCardimg/${editItem?._id}`, requestOptions)
                .then((response) => response.json())
                .then((result) => {console.log(result)
                    getIdCard();
                    
                    Swal.fire("Success!", "Image updated successfully.", "success");
                })
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
            
        }
    }


    const UpdateAlldata = async () => {
        try {

            const formdata = new FormData();
formdata.append("name", editFormData.name);
formdata.append("designation", editFormData.designation);
formdata.append("department", editFormData.department);
formdata.append("companyaddress", editFormData.companyaddress);
formdata.append("emergencycontact", editFormData.emergencycontact);

const requestOptions = {
  method: "PUT",
  body: formdata,
  redirect: "follow"
};

fetch(`https://api.experts4u.in/api/v2/IdCard/UpdateIdCard/${editItem?._id}`, requestOptions)
  .then((response) => response.text())
  .then((result) => console.log(result))
  .catch((error) => console.error(error));

            
        } catch (error) {
            
        }
    }

    return (
        <div className="container-fluid py-5 mt-4">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow">
                        <div className="card-header bg-primary text-white fgvfv">
                            <h4 className="mb-0">Create ID Card</h4>
                        </div>
                        <div className="card-body add-form">
                            <form onSubmit={CardCreate}>
                            <div className='mb-3'>
                                <label className="form-label">Select ServiceProvider</label>
                                <select className="form-control" name="spid" onChange={handleChange} required>
                                    <option value="">Select ServiceProvider</option>
                                    {sp.map((item) => (
                                        <option key={item._id} value={item._id}>
                                            {item.Name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                                <div className="mb-3">
                                    <label className="form-label">Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Photo</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        onChange={handleFileChange}
                                        accept="image/*"
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Designation</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="designation"
                                        value={formData.designation}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Department</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="department"
                                        value={formData.department}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Company Address</label>
                                    <textarea
                                        className="form-control"
                                        name="companyaddress"
                                        value={formData.companyaddress}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Emergency Contact</label>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        name="emergencycontact"
                                        value={formData.emergencycontact}
                                        onChange={handleChange}
                                        pattern="[0-9]{10}"
                                        required
                                    />
                                </div>
                                <button type="submit" className="btn btn-primary">
                                    Create ID Card
                                </button>
                            </form>
                        </div>
                    </div>
                </div>

                {/* table */}
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">ID Card List</h4>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Image</th>
                                            <th>Name</th>
                                            <th>EmpCode</th>
                                            <th>Department</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {idcard.map(item => (
                                            <tr key={item._id}>
                                                <td>
                                                    <img src={`https://api.experts4u.in${item?.image}`} width="50" height="50" />
                                                </td>
                                                <td>{item.name}</td>
                                                <td>{item.empcode}</td>
                                                <td>{item.department}</td>
                                                <td>
                                                    <button className="btn btn-primary btn-sm mr-2" onClick={() => handleEdit(item)}>Edit</button>
                                                    <button className="btn btn-danger btn-sm mr-2" onClick={() => handleDelete(item._id)}>Delete</button>
                                                    <button className="btn btn-info btn-sm" onClick={() => handleView(item._id)}>View</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

            {/* edit modal */}
            {ShowModal && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit ID Card</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={() => setShowModal(false)}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleEditFormSubmit}>
                                    <div className="text-center mb-4">
                                        <div className="position-relative d-inline-block">
                                            {(editFormData.image || editItem?.image) && (
                                                <div className="mb-3">
                                                    <img 
                                                        src={editFormData.image instanceof File ? 
                                                            URL.createObjectURL(editFormData.image) : 
                                                            `https://api.experts4u.in${editItem?.image}`
                                                        } 
                                                        alt="ID Card" 
                                                        style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                                    />
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-sm btn-danger mt-2"
                                                        onClick={removeImage}
                                                    >
                                                        Remove Image
                                                    </button>
                                                    {/* update image */}
                                                    {
                                                        editFormData?.image instanceof File &&
<button 
                                                        type="button" 
                                                        className="btn btn-sm btn-primary mt-2"
                                                        onClick={() => updateImage(editItem?._id)}
                                                        
                                                    >
                                                        Update Image
                                                    </button>
                                                    }
                                                    
                                                    
                                                </div>
                                            )}
                                            <div className="mt-2">
                                                <input
                                                    type="file"
                                                    className="form-control w-100"
                                                    onChange={handleEditImageUpload}
                                                    accept="image/*"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                  

                                    <div className="mb-3">
                                        <label className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={editFormData.name}
                                            onChange={handleEditChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Designation</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="designation"
                                            value={editFormData.designation}
                                            onChange={handleEditChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Department</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="department"
                                            value={editFormData.department}
                                            onChange={handleEditChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Company Address</label>
                                        <textarea
                                            className="form-control"
                                            name="companyaddress"
                                            value={editFormData.companyaddress}
                                            onChange={handleEditChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Emergency Contact</label>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            name="emergencycontact"
                                            value={editFormData.emergencycontact}
                                            onChange={handleEditChange}
                                            pattern="[0-9]{10}"
                                            required
                                        />
                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                            Close
                                        </button>
                                        <button type="submit" className="btn btn-primary">
                                            Save Changes
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* edit modal */}

            {/* View Modal */}
            {showViewModal && viewItem && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">ID Card Details</h5>
                                <button type="button" className="btn-close" onClick={() => setShowViewModal(false)}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="text-center mb-4">
                                    <img 
                                        src={`https://api.experts4u.in${viewItem.image}`}
                                        alt="ID Card" 
                                        style={{ width: '200px', height: '200px', objectFit: 'cover' }}
                                        className="mb-3"
                                    />
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <table className="table table-bordered">
                                            <tbody>
                                                <tr>
                                                    <th>Name</th>
                                                    <td>{viewItem.name}</td>
                                                </tr>
                                                <tr>
                                                    <th>Designation</th>
                                                    <td>{viewItem.designation}</td>
                                                </tr>
                                                <tr>
                                                    <th>Department</th>
                                                    <td>{viewItem.department}</td>
                                                </tr>
                                                <tr>
                                                    <th>Company Address</th>
                                                    <td>{viewItem.companyaddress}</td>
                                                </tr>
                                                <tr>
                                                    <th>Emergency Contact</th>
                                                    <td>{viewItem.emergencycontact}</td>
                                                </tr>
                                                <tr>
                                                    <th>Employee Code</th>
                                                    <td>{viewItem.empcode}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowViewModal(false)}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* View Modal End */}
        </div>
    )
}

export default AddIdCard